import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { globals } from '../globals';
import { Rastreio } from '../models/rastreio';
import { RastreioLog } from '../models/rastreio-log';
import { RastreioDTO } from '../models/rastreio-acess';

@Injectable({
  providedIn: 'root'
})
export class RastreioService {

  constructor(private http: HttpClient) { }

  consultarPorId(id) {
    return this.http.get<any>(globals.apiUrl + '/api/Rastreio/Buscar',
      { params: new HttpParams().set('id', id) });
  }

  consultarRastreio(idCupom) {
    let parametros = new HttpParams();

    if (idCupom) {
      parametros = parametros.set('idCupom', idCupom);
    }

    return this.http.get<Rastreio[]>(globals.apiUrl + '/api/Rastreio/ListarRastreio',
      { params: parametros }
    );
  }

  consultarLogRastreio(idCupom) {
    let parametros = new HttpParams();

    if (idCupom) {
      parametros = parametros.set('idCupom', idCupom);
    }

    return this.http.get<RastreioLog[]>(globals.apiUrl + '/api/Rastreio/ListarLogRastreio',
      { params: parametros }
    );
  }

  consultarLink(idCupom, url) {
    let parametros = new HttpParams()
      .set('idCupom', idCupom)
      .set('url', url);

    return this.http.get<any>(globals.apiUrl + '/api/Rastreio/BuscarLinkRastreio',
      { params: parametros }
    );
  }

  validaLink(link) {
    let parametros = new HttpParams()
      .set("url", link);

    return this.http.get<RastreioDTO>(`${globals.apiUrl}/api/Rastreio/ValidaLink`,
      { params: parametros }
    );
  }
}
